/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request to generate MCQs.
 */
export interface MCQGenerationRequest {
  /**
   * @minimum 1
   * @maximum 10
   */
  count?: number;
  /** Optional task IDs to use as additional context */
  taskIds?: string[];
  /** Optional resource IDs to use as context */
  resourceIds?: string[];
}
